import { Badge, Button, createTheme } from '@mantine/core';
import { breakpoints, colors, fontSize, spacings } from './theme';
import { cn } from '@/utils/classNames';

const button = Button.extend({
  defaultProps: {
    // Align icon vertically with text
    styles: { section: { height: 20, width: 20 } },
  },
  classNames: (theme, props) => {
    const [color] = props.color?.split('.') || ['primary'];

    return {
      root: cn(
        props.variant === 'light' &&
          (color === 'primary' ? 'bg-primary-100 hover:bg-primary-200' : undefined),

        props.variant === 'subtle' && (color === 'primary' ? 'hover:bg-primary-200' : undefined),
      ),
    };
  },
});

const actionIcon = Button.extend({
  classNames: (theme, props) => {
    const [color] = props.color?.split('.') || ['primary'];

    return {
      root: cn(
        props.variant === 'light' &&
          (color === 'primary' ? 'bg-primary-100 hover:bg-primary-200' : undefined),

        props.variant === 'subtle' && (color === 'primary' ? 'hover:bg-primary-200' : undefined),
      ),
    };
  },
});

const badge = Badge.extend({
  // Avoid uppercase in badge
  defaultProps: { styles: { label: { textTransform: 'none' } } },
});

const mantineTheme = createTheme({
  colors,
  components: { Button: button, ActionIcon: actionIcon, Badge: badge },
  spacing: spacings,
  fontSizes: fontSize,
  breakpoints: breakpoints,
  primaryColor: 'primary',
  defaultRadius: 'md',
  defaultGradient: {
    from: 'primary.6',
    to: 'primary.9',
    deg: 45,
  },
  fontFamily: 'Geist, sans-serif',
  fontFamilyMonospace: 'Geist, sans-serif',
  headings: {
    fontFamily: 'Geist, sans-serif',
  },
});

export type ColorsType = keyof typeof colors;

export default mantineTheme;
